{
	"title": "Historique des transactions {{productName}}",
	"item": {
		"time": "Heure",
		"description": "Description",
		"transactionId": "ID de transaction",
		"showIds": "Afficher les identifiants",
		"depositTitle": "Assurance par DNV, permettant un dépôt dans la banque carbone",
		"depositDescription": "Une fois que l’organisme d’assurance tiers « DNV » a assuré le volume de carbone capturé stocké dans un système numérique Monitor-Report-Verify, un nouveau dépôt est effectué dans la banque carbone.",
		"withdrawalTitle": "Facture au fournisseur, déclenchant un retrait de la banque carbone",
		"withdrawalDescription": "Avec la facturation du matériau evoZero au fournisseur, un retrait de la banque carbone a été exécuté.",
		"transferTitle": "Transfert des réductions carbone au titulaire de la déclaration",
		"transferDescription": "Le fournisseur a initié le transfert des réductions carbone au titulaire de la déclaration, sur la base du volume de matériau evoZero intégré au produit livré."
	},
	"proofIdsModal": {
		"titleTransactions": "Voir les transactions",
		"titleMeasurements": "Voir les mesures",
		"paragraph1": "Une étape du processus de transaction sur {{productName}} consiste à agréger les transactions dans le registre distribué. Ci-dessous, vous trouverez une liste de liens vers des services tiers où vous pouvez consulter ces transactions.",
		"paragraph2": "Veuillez noter que ces liens vous redirigeront vers des sites externes proposant des fonctionnalités de consultation des transactions.",
		"open": "Ouvrir",
		"close": "Fermer"
	},
	"errors": {
		"fetch": "Impossible de récupérer l’historique d’activité"
	}
}
